import green from '@material-ui/core/colors/green';

const isDemo = process.env.REACT_APP_THEME === 'demo';

export const styles = (theme) => ({
  classlinkBanner: {
    padding: '8px 16px',
    marginBottom: 8,
    borderRadius: 4,
    backgroundColor: '#e8f4fb',
    border: '1px solid #bcdff1',
  },
  root: {
    padding: '16px 36px',
  },
  coloredRoot: {},
  tableContainer: {
    marginTop: theme.spacing.unit * 3,
  },
  content: {
    margin: 'auto',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  deleteModal: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: isDemo ? '0 8px 28px rgba(58,166,185,0.12)' : theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: 'none',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    ...(isDemo ? { borderRadius: 16, background: '#fff', border: '1px solid rgba(191,247,255,0.6)' } : {}),
  },
  editModal: {
    position: 'absolute',
    width: theme.spacing.unit * 105,
    background: isDemo
      ? '#fff'
      : 'linear-gradient(0deg, rgba(175, 228, 236, 0.65) 0%, rgba(255, 255, 255, 0) 100%), #FFFFFF;',
    boxShadow: isDemo ? '0 8px 28px rgba(58,166,185,0.12)' : theme.shadows[5],
    padding: theme.spacing.unit * 3,
    outline: 'none',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    maxHeight: theme.spacing.unit * 90,
    overflowY: 'scroll',
    ...(isDemo ? { borderRadius: 16, border: '1px solid rgba(191,247,255,0.6)' } : {}),
  },
  head: {
    textTransform: 'capitalize',
    color: theme.palette.primary.main,
    display: isDemo ? 'flex !important' : 'flex',
    justifyContent: isDemo ? 'center !important' : 'center',
    alignItems: 'center',
    padding: isDemo ? '0 !important' : 0,
    flexShrink: 0,
    flexGrow: 0,
    // narrower header type + tighter line-height so the wider demo font wraps cleanly
    // in the fixed ~86px columns instead of overlapping
    ...(isDemo ? { fontSize: '0.68rem', lineHeight: 1.2 } : {}),
  },

  iconHead: {
    width: 100,
    textTransform: 'capitalize',
    color: theme.palette.primary.main,
    display: isDemo ? 'flex !important' : 'flex',
    justifyContent: isDemo ? 'center !important' : 'center',
    alignItems: 'center',
    padding: isDemo ? '0 !important' : 0,
    flexShrink: 0,
    flexGrow: 0,
    ...(isDemo ? { fontSize: '0.68rem', lineHeight: 1.2 } : {}),
  },

  tableHead: {
    display: 'block',
    width: 1900,
  },

  tableRow: {
    display: 'flex',
    // Header row: keep prod's 60px — the multi-line column labels need the room, and the
    // wider Source Sans Pro overlaps if this is shrunk. (Data rows compact separately.)
    minHeight: '60px',
    width: '100%',
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  table: {
    // Demo: flatten the cyan gradient to plain white so the wrapping panel reads clean.
    background: isDemo
      ? '#fff'
      : 'linear-gradient(0deg, rgba(175, 228, 236, 0.65) 0%, rgba(255, 255, 255, 0) 100%), #FFFFFF;',
    display: 'block',
    overflowX: 'auto',
  },
  tableBody: {
    display: 'block',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 'calc(100vh - 140px)',
    width: 1900,
  },
  pagination: {
    position: 'absolute',
    right: 0,
  },
  searchWrapper: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  input: {
    marginLeft: theme.spacing.unit,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },

  // ---- Demo-only "Polished & Warm" structural styles (no effect in prod) ----
  // Stat card row above the table.
  statCardRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 18,
    marginBottom: 22,
    marginTop: theme.spacing.unit * 2,
  },
  statCard: {
    position: 'relative',
    background: '#fff',
    padding: '18px 22px',
    borderRadius: 16,
    boxShadow: '0 6px 20px rgba(58,166,185,0.10)',
    border: '1px solid rgba(191,247,255,0.6)',
    minWidth: 150,
    flex: '0 0 auto',
  },
  statNumber: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: '#2c3e40',
    lineHeight: 1.1,
  },
  statLabel: {
    fontSize: '0.82rem',
    color: '#7c8a8d',
    marginTop: 2,
  },
  // ---- Editable stat-card chrome (demo-only) ----
  statCardsBlock: {
    marginTop: theme.spacing.unit * 2,
  },
  statCardsToolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    minHeight: 32,
    marginBottom: 4,
  },
  statCardsHint: {
    marginRight: 'auto',
    fontSize: '0.78rem',
    color: '#7c8a8d',
  },
  statCardsEditBtn: {
    padding: 6,
    color: '#3aa6b9',
  },
  statCardRemove: {
    position: 'absolute',
    top: 4,
    right: 4,
    padding: 2,
    color: '#b04a4a',
    background: 'rgba(255,255,255,0.85)',
    '&:hover': {
      background: '#fff',
    },
  },
  statCardAdd: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '18px 22px',
    borderRadius: 16,
    border: '1px dashed rgba(58,166,185,0.55)',
    background: 'rgba(241,252,255,0.55)',
    minWidth: 150,
    flex: '0 0 auto',
    cursor: 'pointer',
    color: '#3aa6b9',
    transition: 'background 0.15s ease',
    '&:hover': {
      background: 'rgba(214,247,255,0.8)',
    },
  },
  statCardAddPlus: {
    fontSize: '1.6rem',
    fontWeight: 700,
    lineHeight: 1,
  },
  statCardAddLabel: {
    fontSize: '0.78rem',
    color: '#7c8a8d',
    marginTop: 4,
    textAlign: 'center',
  },

  // Panel that frames the roster table.
  panel: {
    background: '#fff',
    borderRadius: 18,
    overflow: 'hidden',
    boxShadow: '0 8px 28px rgba(58,166,185,0.12)',
    border: '1px solid rgba(191,247,255,0.6)',
    marginTop: theme.spacing.unit * 3,
  },
  panelHeader: {
    padding: '14px 22px',
    background: 'linear-gradient(180deg,#f1fcfe,#ffffff)',
    borderBottom: '1px solid #e4eef0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  panelTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    color: '#2c3e40',
  },
  // Search box restyled to sit in the panel header (flat input chrome).
  searchWrapperDemo: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 320,
    border: '1px solid #e4eef0',
    borderRadius: 10,
    background: '#fbffff',
    boxShadow: 'none',
  },

  // Top action button row tightening (de-uppercase is global; we tighten spacing/hover).
  actionButtonGroupDemo: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },

  // Inline empty state shown only when the roster collapses to blank.
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '64px 24px',
  },
  emptyStateIcon: {
    fontSize: 56,
    color: '#cdd7d9',
    marginBottom: 8,
  },
  emptyStateHeadline: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#5d6b6d',
  },
  emptyStateSubtext: {
    fontSize: '0.85rem',
    color: '#9ca3af',
    marginTop: 4,
  },
});

export default 'StudentRoster.styles.js';
